module.exports = __webpack_public_path__ + "media/images/gfx/save_xs-120c950b048166574df6aa1587fb8d69.gif";